import { ProviderColorTheme } from '../SocialButtonsOptions/constants';
import { SocialButtonClassName } from './SocialButton.types';
import { IDP_APPDEFIDS } from '../../../constants';
import { IStylesContextValue } from '@wix/tpa-settings';
import GoogleIcon from './assets/google-icon.svg';
import FacebookIconBlue from './assets/facebook-icon-blue.svg';
import FacebookIconWhite from './assets/facebook-icon-white.svg';
import { SSOIcon } from './assets/SSOIcon';

// Re-export node-safe types and functions for consumers
export type { ThemeConfig } from './providerThemeStyles';
export { getThemeStyles } from './providerThemeStyles';

// Import the styles data to combine with icons
import { PROVIDER_THEME_STYLES, ThemeConfig } from './providerThemeStyles';

export const PROVIDER_THEME_CONFIG: Record<
  string,
  {
    themeParam: string;
    themes: Record<ProviderColorTheme, ThemeConfig>;
    icons: Record<ProviderColorTheme, React.ComponentType>;
  }
> = {
  [IDP_APPDEFIDS.google]: {
    ...PROVIDER_THEME_STYLES[IDP_APPDEFIDS.google],
    icons: {
      [ProviderColorTheme.OUTLINE]: GoogleIcon,
      [ProviderColorTheme.LIGHT]: GoogleIcon,
      [ProviderColorTheme.DARK]: GoogleIcon,
    },
  },
  [IDP_APPDEFIDS.facebook]: {
    ...PROVIDER_THEME_STYLES[IDP_APPDEFIDS.facebook],
    icons: {
      [ProviderColorTheme.OUTLINE]: FacebookIconBlue,
      [ProviderColorTheme.LIGHT]: FacebookIconWhite,
      [ProviderColorTheme.DARK]: FacebookIconWhite,
    },
  },
  [IDP_APPDEFIDS.sso]: {
    ...PROVIDER_THEME_STYLES[IDP_APPDEFIDS.sso],
    icons: {
      [ProviderColorTheme.OUTLINE]: SSOIcon,
      [ProviderColorTheme.LIGHT]: SSOIcon,
      [ProviderColorTheme.DARK]: SSOIcon,
    },
  },
};

export enum SSOButtonType {
  // noinspection JSUnusedGlobalSymbols
  BUTTON = 0,
  LINK = 1,
}

// Utility function to get theme enum value
export const getProviderColorTheme = (
  providerId: string,
  styles: IStylesContextValue,
  stylesParams: any,
): ProviderColorTheme => {
  const config = PROVIDER_THEME_CONFIG[providerId];
  return styles.get(stylesParams[config.themeParam]) as ProviderColorTheme;
};

// Utility function to get CSS class name from theme and provider ID
export const getThemeClassName = (
  theme: ProviderColorTheme,
  providerId: string,
): SocialButtonClassName => {
  const config = PROVIDER_THEME_CONFIG[providerId];
  return config?.themes[theme]?.className || 'sso';
};

// Utility function to get icon component from theme and provider ID
export const getThemeIcon = (
  theme: ProviderColorTheme,
  providerId: string,
): React.ComponentType | null => {
  const config = PROVIDER_THEME_CONFIG[providerId];
  return config?.icons[theme] || null;
};
